import { render, staticRenderFns } from "./WorkerList.vue?vue&type=template&id=38e2e80b&scoped=true&"
import script from "./WorkerList.vue?vue&type=script&lang=ts&"
export * from "./WorkerList.vue?vue&type=script&lang=ts&"
import style0 from "./WorkerList.vue?vue&type=style&index=0&id=38e2e80b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2e80b",
  null
  
)

export default component.exports